(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var initHeader = function () {
    var self = $(this);
    var nav = $('.nav-container');
    var content = $('#main-content');
    var search = $('.cc--search-form');
    var alertHeight = 0;
    var $desktopТavHeight;
    var $horNav = $('.cc--horizontal-strip');
    var horNavHeight = 0;
    var $heroStories = $('.cc--hero-stories-full-width-carousel');
    var $heroStoriesTitle = $('.f--page-title', $heroStories);
    var $horizontalStrip = $('.horizontal-strip-nav');
    var headerHeight = self.height();
    var $actualHeaderHeight = $('.header-wrapper').height();

    $('.c--header').css('background', 'none');

    function changeHeaderHeight() {
      var $alertsWrapper = $('.alerts-wrapper');
      $('.cc--header').css('position', 'fixed');

      if ($horNav.length) {
        var viewportHeight = window.visualViewport.height;
        horNavHeight = $horNav.height();

        $horizontalStrip.css('height', 'calc(100vh - ' + headerHeight + 'px');
        $horizontalStrip.css('top', horNavHeight);

        $horizontalStrip.find('.submenus-wrapper').css('height', viewportHeight - headerHeight + 'px');
      }

      $desktopТavHeight = $('.desktop-nav').height();
      headerHeight = $('.cc--header').height();
      nav.css('height', 'calc(100vh - ' + (headerHeight - horNavHeight) + 'px');
      nav.css('top', $desktopТavHeight);
      search.css('top', $desktopТavHeight);

      if (!$('.cc--simplified-landing-hero').length && !$('.cc--hero-stories-full-width-carousel').length) {
        content.css('margin-top', headerHeight);
      }
      else {
        $('body').addClass('has-emergency-banner');
        alertHeight = $alertsWrapper.height();
        content.css('margin-top', alertHeight);
        $alertsWrapper.addClass('loaded');

        if ($heroStories.length) {
          $heroStoriesTitle.css('top', $actualHeaderHeight);
        }
      }
    }
    changeHeaderHeight();

    waitForElementToDisplay('.cc--emergency-alert', function() {
      changeHeaderHeight();
    },200,3500);

    new ResizeObserver(() => {
      changeHeaderHeight();
    }).observe(document.body);

    waitForElementToDisplay('.cc--admission-notice', function() {
      changeHeaderHeight();
    },200,3500);

    // Listen for a class change
    const btn = document.querySelector('body')
    const options = {
      attributes: true
    }

    function callback(mutationList, observer) {
      mutationList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          changeHeaderHeight();
        }
      });
    }

    const observer = new MutationObserver(callback);
    observer.observe(btn, options);

    visualViewport.onresize = () => {
      var viewportHeight = window.visualViewport.height;
      var $desktopТavHeight = $('.desktop-nav').height();
      search.css('height', viewportHeight + $desktopТavHeight + 'px');
    };

    function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
              callback()
              return;
            }
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.header = {
    attach: function (context) {
      $(context)
        .find('.cc--header')
        .once('header')
        .each(function () {
          initHeader.apply(this);
        });
    },
  };
})(jQuery);
